import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import './newStores.css';

function NewStores() {
  const [address, setAddress] = useState("");
  const [stores, setStores] = useState([]);
  const location = useLocation();

  useEffect(() => {
    // Get the address from query params
    // const queryParams = new URLSearchParams(location.search);
    // const addressParam = queryParams.get("address");

    // if (addressParam) {
    //   setAddress(addressParam);
    //   fetchStores(addressParam); // Fetch stores based on location
    // }
    fetchStores();
  }, [location]);

  // Fetch stores from the API
  const fetchStores = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SOCKET_URL}/api/new-stores`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          // body: JSON.stringify({ address: userAddress }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setStores(data.data);
      } else {
        console.error("Error fetching stores:", data.message);
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 rounded-lg shadow-md mt-6 mb-6">
      <div className="p-6">
        {/* Location Display - Top Left */}
        <div className="mb-6">
          <h1 className="text-xl font-bold text-gray-700 text-center">New Stores</h1>
        </div>

        {/* Store Listings - 1 Row, 3 Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {stores.length > 0 ? (
            stores.map((store) => (
              // <div key={store.id} className="bg-white shadow-md rounded-lg p-4 store-item">
              //   <img
              //     src={store.image || "https://bagsandscreens.com/uploads/pizza_max_resized_81.jpg"}
              //     alt={store.name}
              //     className="w-full h-50 object-cover rounded-md"
              //     onError={(e) => {
              //       e.target.src = "https://bagsandscreens.com/uploads/pizza_max_resized_81.jpg";
              //     }}
              //   />
              //   <span>Comming soon</span>
              //   <h3 className="text-lg font-semibold mt-3">{store.name}</h3>
              //   <p className="text-gray-600">{store.address}</p>
              //   <p className="text-blue-600 font-semibold mt-2">
              //   </p>
                
              // </div>

              <div className="bestseller_card">
                <div
                  className="thumble-img"
                  style={{
                    backgroundImage: `url('https://bagsandscreens.com/uploads/pizza_max_resized_81.jpg')`,
                  
                  }}
                ></div>
                <div className="bodytext">
                  <h5>{store.name || "Untitled"}</h5>
                  <p>
                  📍 {store.address}
                  </p>
                  <a href="#" className="outline-btnorder">
                    Comming soon
                  </a>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center col-span-3">
              No stores found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewStores;
